import { Grid, Paper } from "@mui/material";
import CustomText from "components/typography/CustomText";
import { formattedNumber } from "lib/formatter";
import { serverPost } from "lib/serverRequest";
import moment from "moment";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { openLoading } from "store/reducers/tools";

export const SelectDayDetail = () => {
  const [selDay, setSelDay] = useState(new Date());
  const [data, setData] = useState({});

  const handleChangeDate = (v) => {
    setSelDay(v);
  };

  const loadOverviewData = () => {
    openLoading(true);
    serverPost({
      url: "weeklyslots/selDaystatistics",
      data: { selDay: moment(selDay).format("YYYY-MM-DD") },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) return;
        setData(res);
      },
    });
  };

  useEffect(() => {
    loadOverviewData();
    //eslint-disable-next-line
  }, [selDay]);

  return (
    <div>
      <div className="w-full pb-5 flex justify-end">
        <div>
          <DatePicker
            className={`px-2 py-1 border rounded border-white-gray`}
            selected={selDay}
            dateFormat="dd MMM yyyy"
            onChange={handleChangeDate}
            placeholderText="Select a weekday"
          />
        </div>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6} md={3}>
          <Paper className="flex flex-col justify-between p-4 rounded h-full">
            <CustomText className="text-sm sm:text-base break-words">
              Total Active {<br />} Subscriptions
            </CustomText>
            <CustomText className="text-2xl text-center pt-4 pl-3" bold>
              {formattedNumber(data?.total_sub)}
            </CustomText>
          </Paper>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Paper className="flex flex-col justify-between p-4 rounded h-full">
            <CustomText className="text-sm sm:text-base break-words">
              Total Pie Club {<br />} Members
            </CustomText>
            <CustomText className="text-2xl text-center pt-4 pl-3" bold>
              {formattedNumber(data?.total_users)}
            </CustomText>
          </Paper>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Paper className="flex flex-col justify-between p-4 rounded h-full">
            <CustomText className="text-sm sm:text-base break-words">
              Average Subscription {<br />}Frequency
            </CustomText>
            <CustomText className="text-2xl text-center pt-4 pl-3" bold>
              {formattedNumber(
                data?.aver_frequency === "NaN" ? 0 : data?.aver_frequency ?? 0
              )}
            </CustomText>
          </Paper>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Paper className="flex flex-col justify-between p-4 rounded h-full">
            <CustomText className="text-sm sm:text-base break-words">
              Average Number of {<br />}Skipped Orders
            </CustomText>
            <CustomText className="text-2xl text-center pt-4 pl-3" bold>
              {formattedNumber(
                data?.total_skipped === "NaN" ? 0 : data?.total_skipped ?? 0
              )}
            </CustomText>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};
